module.exports = __webpack_public_path__ + "media/images/icon-brand-positioning-626bab376d98a7c2ab158136c398b444.svg";